import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import React from 'react';
import ReactDOM from 'react-dom/client';

import { PasswordRequest } from './PasswordRequest';

const element = document.getElementById('pwrequest') as HTMLElement;
const root = ReactDOM.createRoot(element);
const client = new QueryClient({
    defaultOptions: {
        queries: {
            cacheTime: 1000 * 60 * 60 * 24, // 24 hours
            staleTime: 1000 * 30, //30 seconds
        },
    },
});
if (element) {
    root.render(
        <React.StrictMode>
            <QueryClientProvider client={client}>
                <PasswordRequest />
            </QueryClientProvider>
        </React.StrictMode>,
    );
}
